import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MiniLoadingSpinner from '../../../components/Spinners/MiniLoadingSpinner';
import CreateCompany from './components/Company/CreateCompany';
import CreateLocal from './components/Local/CreateLocal';
import CreateSalones from './components/Salones/CreateSalones';
import CreateWorkstation from './components/Workstation/CreateWorkstation';
import CreatePuestos from './components/Puesto/CreatePuestos';
import CreateUser from './components/User/CreateUser';
import {
 CreateCompanyRegistration,
 DeleteCompanyRegistration,
} from '../../../crud/configuration_api/companies';
import {
 CreateLocalRegistration,
 DeleteLocalRegistration,
} from '../../../crud/management_api/locales';
import { initDefaultSalonesByLocalId, deleteSalonesRegistration } from '../../../crud/management_api/salones';
import {
 DeleteWorkstationRegistration,
 createWorkstationFromListRegistration,
} from '../../../crud/management_api/workstations';
import {
 DeletePuestoRegistration,
 createPuestoFromListRegistration,
} from '../../../crud/management_api/puestos';
import {
 CreateUserRegistration,
 DeleteUserRegistration,
} from '../../../crud/users_api/users';
import { getAccountCreationCodeByCode } from '../../../crud/configuration_api/account_creation_codes';
import { AxiosResponse } from 'axios';
import './Registration.scss';


import { setCompanyId, setLocalId } from '../../../crud/configuration_api/account_creation_codes';

import { removeCompanyId,removeLocalId } from '../../../crud/configuration_api/account_creation_codes';


const PageManager = () => {
 const { code } = useParams();
 const navigate = useNavigate();


 // <-- Cambiado: arranca en la página de compañía (índice 0)
 const [index, setIndex] = useState(0);
 const [prevIndex, setPrevIndex] = useState(0);


 const [loading, setLoading] = useState(false);
 const [payload, setPayload] = useState<any>(null);
 const [error, setError] = useState(false);
 const [isValidCode, setIsValidCode] = useState<boolean | null>(null);
 const [countries, setCountries] = useState<any[]>([]);
 const [states, setStates] = useState<any[]>([]);
 const [cities, setCities] = useState<any[]>([]);
 const [companyName, setCompanyName] = useState('');
 const [workstation, setWorkstation] = useState<any[]>(() => {
   const mem = localStorage.getItem('RegistrationMemory');
   const parsedMem = mem ? JSON.parse(mem) : {};
   return parsedMem[3] || [];
 });

 useEffect(() => {
    const fetchCodeData = async () => {
      if (code) {
        try {
          const response: AxiosResponse<any> = await getAccountCreationCodeByCode(code);
          if (response.data) {
            setIsValidCode(true);
            setPayload(response.data);
            setCountries(response.data.countries || []);
            setStates(response.data.states || []);
            setCities(response.data.cities || []);
            setCompanyName(response.data.company_name || '');
            // Sincronizar local_id de localStorage con el de la respuesta
            const mem = localStorage.getItem('RegistrationMemory');
            const parsedMem = mem ? JSON.parse(mem) : {};
            const localStorageLocalId = parsedMem[1]?.local_id;
            const apiLocalId = response.data.local_id;
            if (apiLocalId && localStorageLocalId !== apiLocalId) {
              parsedMem[1] = { ...parsedMem[1], local_id: apiLocalId };
              localStorage.setItem('RegistrationMemory', JSON.stringify(parsedMem));
            }
            // Lógica de navegación automática según los datos recibidos
            if (response.data.company_id && response.data.local_id) {
              setIndex(2); // Ir a page 2 (salones)
            } else if (response.data.company_id) {
              setIndex(1); // Ir a page 1 (local)
            } else {
              setIndex(0); // Ir a page 0 (compañía)
            }
          } else {
            setIsValidCode(false);
          }
        } catch (error) {
          console.error('Error fetching account creation code:', error);
          setIsValidCode(false);
        }
      } else {
        setIsValidCode(false);
      }
    };
  
    fetchCodeData();
  }, [code]);


 useEffect(() => {
   setIsValidCode(true);
 }, [code]);


 useEffect(() => {
   if (isValidCode === false) {
     // navigate('/login');
   }
 }, [isValidCode, navigate]);


 const moveNextPage = () => setIndex((i) => i + 1);
 const moveBack = () => setIndex((i) => (i > 0 ? i - 1 : 0));
 const moveFunctions = { next: moveNextPage, back: moveBack };


 const handleCleanIdFromPayloadAndStorage = (stepKey: number, idKey: string) => {
  // Limpia el id del payload y del localStorage para el paso dado
  setPayload((prev: any) => {
    if (!prev) return prev;
    const newPayload = { ...prev };
    delete newPayload[idKey];
    return newPayload;
  });
  const mem = localStorage.getItem('RegistrationMemory');
  const parsedMem = mem ? JSON.parse(mem) : {};
  if (parsedMem[stepKey]) {
    delete parsedMem[stepKey][idKey];
    localStorage.setItem('RegistrationMemory', JSON.stringify(parsedMem));
  }
};

const PageMap: {
  [key: number]: {
    page: JSX.Element;
    nextFunction: (payload: any) => Promise<AxiosResponse<any>>;
    backFunction: (code: string) => Promise<AxiosResponse<any>>;
  };
} = {
   0: {
     page: (
       <CreateCompany
         index={index}
         moveFunctions={moveFunctions}
         setPayload={setPayload}
         accountCode={code || ''}
         countries={countries}
         setCountries={setCountries}
         states={states}
         setStates={setStates}
         cities={cities}
         setCities={setCities}
         companyName={companyName}
         setCompanyName={setCompanyName}
         payload={payload}
       />
     ),
     nextFunction: async (payload) => {
       // Si ya existe company_id en el payload, no crear de nuevo
       if (payload?.company_id) {
         return {
           data: { company_id: payload.company_id },
           status: 200,
           statusText: 'OK',
           headers: {},
           config: { headers: {} },
         } as AxiosResponse<any, any>;
       }
       // Crear compañía y setear company_id en el código de invitación
       const payloadWithPlan = { ...payload, plan_id: payload?.plan_id || 6 };
       const response = await CreateCompanyRegistration(payloadWithPlan);
       if (response?.data?.company_id && payload?.invitation_code_id) {
         try {
           await setCompanyId(payload.invitation_code_id, response.data.company_id);
         } catch (e) {
           console.error('Error al setear company_id en el código de invitación:', e);
         }
       }
       return response;
     },
     backFunction: async (code) => {
       // Primero limpiar en el código de invitación, luego eliminar en backend usando el código de invitación
       if (payload?.invitation_code_id && payload?.company_id) {
         try {
           await removeCompanyId(payload.invitation_code_id);
         } catch (e) {
           console.error('Error al limpiar company_id en el código de invitación:', e);
         }
       }
       const resp = await DeleteCompanyRegistration(code);
       // Limpiar company_id del payload y localStorage
      handleCleanIdFromPayloadAndStorage(0, 'company_id');
      return resp;
     },
   },
   1: {
     page: (
       <CreateLocal
         index={index}
         moveFunctions={moveFunctions}
         setPayload={setPayload}
         accountCode={code || ''}
         payload={payload}
         states={states}
         setStates={setStates}
         cities={cities}
         setCities={setCities}
       />
     ),
     nextFunction: async (payload) => {
       // Si ya existe local_id en el payload, no crear de nuevo
       if (payload?.local_id) {
         return {
           data: { local_id: payload.local_id },
           status: 200,
           statusText: 'OK',
           headers: {},
           config: { headers: {} },
         } as AxiosResponse<any, any>;
       }
       // Crear local y setear local_id en el código de invitación
       const response = await CreateLocalRegistration(payload);
       if (response?.data?.local_id && payload?.invitation_code_id) {
         try {
           await setLocalId(payload.invitation_code_id, response.data.local_id);
         } catch (e) {
           console.error('Error al setear local_id en el código de invitación:', e);
         }
       }
       return response;
     },
     backFunction: async (code) => {
       // Primero limpiar en el código de invitación, luego eliminar en backend usando el código de invitación
       if (payload?.invitation_code_id && payload?.local_id) {
         try {
           await removeLocalId(payload.invitation_code_id);
         } catch (e) {
           console.error('Error al limpiar local_id en el código de invitación:', e);
         }
       }
       const resp = await DeleteLocalRegistration(code);
       // Limpiar local_id del payload y localStorage
      handleCleanIdFromPayloadAndStorage(1, 'local_id');
      return resp;
     },
   },
   2: {
     page: (
       <CreateSalones
         index={index}
         moveFunctions={moveFunctions}
         setPayload={setPayload}
         code={code || ''}
       />
     ),
     nextFunction: initDefaultSalonesByLocalId,
     backFunction: async (code) => {
      // Si hay local_id, permitir eliminar salones y limpiar local_id si corresponde
      const resp = await deleteSalonesRegistration(code);
      // Si hay local_id en payload, limpiar
      if (payload?.local_id) {
        handleCleanIdFromPayloadAndStorage(1, 'local_id');
      }
      return resp;
    },
   },
   3: {
     page: (
       <CreateWorkstation
         moveFunctions={moveFunctions}
         setPayload={setPayload}
         accountCode={code || ''}
         workstation={workstation}
         setWorkstation={setWorkstation}
       />
     ),
     nextFunction: async (payload) => {
       const response = await createWorkstationFromListRegistration(payload) as any;
       if (response?.data) {
         const mem = localStorage.getItem('RegistrationMemory');
         const parsedMem = mem ? JSON.parse(mem) : {};
         parsedMem[3] = response.data;
         localStorage.setItem('RegistrationMemory', JSON.stringify(parsedMem));
         setWorkstation(response.data);
       }
       return response;
     },
     backFunction: async (code) => {
      const resp = await DeleteWorkstationRegistration(code) as any;
      // Limpiar workstation_id del payload y localStorage si existe
      handleCleanIdFromPayloadAndStorage(3, 'workstation_id');
      return resp;
    },
   },
   4: {
     page: (
       <CreatePuestos
         index={index}
         moveFunctions={moveFunctions}
         setPayload={setPayload}
         accountCode={code || ''}
         workstations={workstation}
       />
     ),
     nextFunction: createPuestoFromListRegistration as (payload: any) => Promise<any>,
     backFunction: async (code) => {
      const resp = await DeletePuestoRegistration(code) as any;
      // Limpiar puesto_id del payload y localStorage si existe
      handleCleanIdFromPayloadAndStorage(4, 'puesto_id');
      return resp;
    },
   },
   5: {
     page: (
       <CreateUser
         index={index}
         moveFunctions={moveFunctions}
         setPayload={setPayload}
         accountCode={code || ''}
       />
     ),
     nextFunction: CreateUserRegistration,
     backFunction: async (code) => {
      const resp = await DeleteUserRegistration(code);
      // Limpiar user_id del payload y localStorage si existe
      handleCleanIdFromPayloadAndStorage(5, 'user_id');
      return resp;
    },
   },
 };


 useEffect(() => {
   const handlePageChange = async () => {
     setLoading(true);
     try {
       if (index !== prevIndex) {
         if (index > prevIndex) {
           const response = await PageMap[prevIndex].nextFunction(payload);
           let newPayload = payload;


           if (prevIndex === 0 && response?.data?.company_id) {
             newPayload = { ...payload, company_id: response.data.company_id };
             setPayload(newPayload);
           }
           if (prevIndex === 1 && response?.data?.local_id) {
             newPayload = { ...payload, local_id: response.data.local_id };
             setPayload(newPayload);
           }
           if (prevIndex === 3 && response?.data?.workstation_id) {
             newPayload = { ...payload, workstation_id: response.data.workstation_id };
             setPayload(newPayload);
           }
           if (prevIndex === 4 && response?.data?.puesto_id) {
             newPayload = { ...payload, puesto_id: response.data.puesto_id };
             setPayload(newPayload);
           }


           const mem = localStorage.getItem('RegistrationMemory');
           const parsedMem = mem ? JSON.parse(mem) : {};
           parsedMem[prevIndex] = newPayload;
           localStorage.setItem('RegistrationMemory', JSON.stringify(parsedMem));


           setPrevIndex(index);


           if (prevIndex === 5) {
             navigate('/login');
             return;
           }
         } else {
           await PageMap[index].backFunction(code || '');
           const mem = localStorage.getItem('RegistrationMemory');
           const parsedMem = mem ? JSON.parse(mem) : {};
           setPayload(parsedMem[index] || null);
           setPrevIndex(index);
         }
         setError(false);
       }
     } catch {
       setError(true);
     } finally {
       setLoading(false);
     }
   };


   if ((index !== prevIndex || error) && isValidCode) {
     handlePageChange();
   } else {
     setLoading(false);
   }
 }, [index, prevIndex, payload, error, code, isValidCode, navigate]);


 return (
   <div className="registration-container-preg">
     <div className="registration-content-preg">
       {isValidCode === null && <MiniLoadingSpinner />}
       {isValidCode === false && (
         <div className="text-center text-danger">
           <p>Código de creación inválido.</p>
         </div>
       )}
       {isValidCode === true && (
         <>
           {loading && <MiniLoadingSpinner />}
           {!loading && PageMap[index]?.page}
         </>
       )}
     </div>
   </div>
 );
};


export default PageManager;

